export default "__VITE_ASSET__CH2wXk5c__"